// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"53c3622b","513":"65fc9c8d","703":"56e78fd4","787":"779c17e0"}[chunkId] + ".chunk.js";
};